(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .controller('TituloElectronicoAngDeleteController',TituloElectronicoAngDeleteController);

    TituloElectronicoAngDeleteController.$inject = ['$uibModalInstance', 'entity', 'TituloElectronico'];

    function TituloElectronicoAngDeleteController($uibModalInstance, entity, TituloElectronico) {
        var vm = this;

        vm.tituloElectronico = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TituloElectronico.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
